<template>
  <div class="site-wrap-wrap">
    <transition name="fade--long">
      <div class="site-loading" v-if="this.$store.getters.getLoadingStatus">
        <img :src="require('@/assets/img/footer-logo-new.svg')" alt="" />
        <div class="_lbl">Загрузка</div>
      </div>
    </transition>
    <transition name="fade--long">
      <div
        class="site-wrap"
        v-bind:class="[
          $route.name ? 'site-wrap--' + $route.name.toLowerCase() : '',
          $route.path == '/' ? 'site-wrap--index' : '',
          headerFixed ? 'site-wrap--h-fixed' : '',
        ]"
        v-if="!this.$store.getters.getLoadingStatus"
      >
        <header
          :class="[
            'header',
            headerFixed ? 'header--fixed' : '',
            headerHide ? 'header--hide' : '',
          ]"
        >
          <div class="_address">
            <span class="_str"
            ><span v-if="$route.path == '/'">Москва, </span
            >{{ resAddress }}</span
            >
            <a
              :href="
                'tel:' +
                this.$store.getters.getContacts.phone.replaceAll(' ', '')
              "
            >
              <span class="_phone" v-if="$route.path != '/'">{{
                  this.$store.getters.getContacts.phone
                }}</span>
              <svg
                class="_icon"
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5997 11.123C12.9609 11.7993 11.9635 12.856 11.1285 13.7458C10.1357 13.0583 9.23834 12.2995 8.51657 11.5358C7.6256 10.5932 6.51084 9.25023 5.90876 8.29931C6.67317 7.49588 7.67329 6.43967 8.40698 5.66389L3.99841 1L1.79916 3.28513L1.79595 3.28852C1.18057 3.9401 0.919651 4.82892 1.02145 5.93073C1.34611 9.45449 5.41856 14.5584 9.01869 17.1143C11.1028 18.5945 14.0991 19.9641 15.8709 18.0895C17.1576 16.7286 17.6492 16.174 17.6698 16.1507L18 15.7781L13.5997 11.123Z"
                  stroke="#141413"
                  stroke-width="1"
                  stroke-miterlimit="10"
                  shape-rendering="optimizeQuality"
                />
              </svg>
            </a>
<!--            <span class="keys-info" v-if="$route.path == '/'"-->
<!--            >Выдаем ключи</span-->
<!--            >-->
          </div>
          <div class="_logo">
            <router-link to="/">
              <svg
                @click="closeMenuAndGoUp"
                class="_logo"
                width="177"
                height="15"
                viewBox="0 0 177 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M31.9277 0.394745H39.7101C43.1025 0.394745 44.8984 1.77632 44.8984 4.34211C44.8984 6.11843 43.7011 7.10527 42.1047 7.69738C43.5016 7.89474 44.2998 10.4605 44.2998 10.4605L45.8962 14.6053V14.8026H43.302C43.302 14.8026 42.5038 12.2368 41.9052 11.25C41.3065 9.67106 41.3065 8.48685 39.1115 8.48685H34.1228V14.8026H31.9277V0.394745ZM39.3111 6.51317C41.5061 6.51317 42.5038 5.92106 42.5038 4.34211C42.5038 2.96053 41.5061 2.36843 39.3111 2.36843H34.3223V6.3158H39.3111V6.51317Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M51.085 0.394745H62.6588V2.5658H53.4795V6.51317H62.0602V8.48685H53.4795V12.6316H62.8584V14.8026H51.085V0.394745Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M67.248 10.0658H69.8422C69.8422 12.0395 71.239 13.0263 73.6336 13.0263C76.0282 13.0263 77.2255 12.0395 77.2255 10.6579C77.2255 6.90792 67.4476 10.4605 67.4476 4.34213C67.4476 1.77634 69.8422 0.197388 73.4341 0.197388C77.0259 0.197388 79.6201 1.9737 79.6201 4.93423H77.0259C76.8264 3.35528 75.6291 2.36844 73.4341 2.36844C71.239 2.36844 70.0417 3.15791 70.0417 4.73686C70.0417 8.28949 79.8196 4.73686 79.8196 10.8553C79.8196 13.4211 77.6246 15.3948 73.6336 15.3948C69.8422 15 67.248 13.2237 67.248 10.0658Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M84.6084 0.394745H87.003V14.8026H84.6084V0.394745Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M92.3916 0.394745H98.7772C103.566 0.394745 106.759 2.96053 106.759 7.50001C106.759 12.0395 103.566 14.8026 98.7772 14.8026H92.3916V0.394745ZM98.7772 12.829C102.17 12.829 104.165 10.8553 104.165 7.50001C104.165 4.34211 102.17 2.36843 98.7772 2.36843H94.7862V12.829H98.7772Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M111.148 0.394745H122.722V2.5658H113.543V6.51317H122.124V8.48685H113.543V12.6316H122.922V14.8026H111.148V0.394745Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M145.87 7.5C145.87 3.15789 149.063 0 153.653 0C157.244 0 160.038 1.97368 160.637 5.32895H158.242C157.644 3.55263 155.848 2.17105 153.653 2.17105C150.46 2.17105 148.265 4.34211 148.265 7.30263C148.265 10.6579 150.46 12.8289 153.453 12.8289C155.848 12.8289 157.843 11.4474 158.242 9.47368H160.637C160.038 12.8289 157.045 15 153.653 15C149.063 15 145.87 12.0395 145.87 7.5Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M165.227 0.394745H176.8V2.5658H167.621V6.51317H176.202V8.48685H167.621V12.6316H177V14.8026H165.227V0.394745Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M12.1727 8.88159H3.99121V10.8553H12.1727V8.88159Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M22.1495 12.6316H19.7549V15H22.1495V12.6316Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M2.79369 15L3.99098 12.4342L4.98873 10.2632L8.18151 3.75L11.3743 10.2632L12.5716 12.4342L13.7689 15H16.5626L8.78016 0H7.58286L0 15H2.79369Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
                <path
                  d="M139.285 0.394737V10.4605L128.909 0H127.911V14.8026H130.306V4.53947L140.682 15H141.68V0.394737H139.285Z"
                  fill="#141413"
                  shape-rendering="optimizeQuality"
                />
              </svg>
            </router-link>
          </div>
          <div class="_right">
            <router-link :to="'/aparts#fav'">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="_fav"
              >
                <path
                  d="M15.5378 3.24854C16.1343 3.24858 16.7251 3.36591 17.2761 3.59424C17.7583 3.79403 18.2018 4.07551 18.5876 4.42529L18.7498 4.57959C19.1717 5.00133 19.5067 5.50209 19.7351 6.05322C19.9634 6.60427 20.0808 7.19503 20.0808 7.7915C20.0808 8.3881 19.9635 8.9796 19.7351 9.53076C19.5067 10.0818 19.1716 10.5827 18.7498 11.0044L10.9998 18.7534L3.25073 11.0044C2.39878 10.1524 1.91968 8.99634 1.91968 7.7915C1.91978 6.5868 2.39887 5.43145 3.25073 4.57959C4.10266 3.72779 5.25792 3.24951 6.46265 3.24951C7.66738 3.24954 8.82265 3.72775 9.67456 4.57959L10.6462 5.55127C10.8414 5.74648 11.158 5.74637 11.3533 5.55127L12.325 4.57959C12.7466 4.15771 13.2475 3.82261 13.7986 3.59424C14.3497 3.36586 14.9412 3.24854 15.5378 3.24854Z"
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>

            <span class="_phone" v-if="$route.path == '/' && !menuActive">{{
                this.$store.getters.getContacts.phone
              }}</span>
            <transition name="fade--l">
              <span
                class="_page-name"
                v-if="$route.path != '/' && !menuActive"
              >{{ activePage.title }}</span
              >
            </transition>
            <span
              v-bind:class="[
                '_menu-btn',
                menuActive ? '_menu-btn--active' : '',
              ]"
              @click="toggleMenu()"
            >
              <span
                :class="[
                  'burger',
                  $route.path == '/' ? 'burger--white' : '',
                  menuActive ? 'burger--close' : '',
                ]"
              ><span></span
              ></span>
              <span class="_word">Меню</span>
            </span>
          </div>
        </header>

        <transition name="fade--l">
          <div v-bind:class="['global-menu']" v-if="menuActive">
            <div class="site-nav">
              <router-link
                :to="page.path"
                v-for="page in pagesForMenu"
                :key="page.id"
              >{{ page.title }}
              </router-link
              >
            </div>
            <div class="global-menu__footer">
              <div class="_res">A. RESIDENCE (C) 2021</div>
              <div class="_menu">
                <router-link to="/contacts" class="mob-hide"
                >Контакты
                </router-link
                >
                <!-- <a href="" class="mob-hide">Проектная декларация</a>
            <span @click="activateTermsPopup" class="mob-hide">Политика&nbsp;конфиденциальности</span> -->
                <a v-if="instUrl" :href="instUrl">Instagram</a>
                <a v-if="tgUrl" :href="tgUrl">Telegram</a>
              </div>
              <div class="_buro">
                Сайт (С)
                <a href="https://madeinburo.com" target="_blank"
                >Made in Buro</a
                >
              </div>
            </div>
          </div>
        </transition>

        <div v-if="$route.path != '/'" class="page-mob-title">
          {{ activePage.title }}
        </div>

        <transition name="fade" mode="out-in">
          <router-view />
        </transition>

        <Footer></Footer>

        <Popup
          v-show="this.$store.getters.getPopupRequestIsActive"
          :title="'Заявка'"
        >
          <form
            autocomplete="off"
            @keydown.enter="sendPopupRequestForm"
            v-if="!requestSent"
          >
            <div class="_inputs">
              <div>
                <input
                  type="text"
                  name="popup_request_name"
                  maxlength="50"
                  placeholder="Ваше имя"
                  v-model="requestPopupName"
                  autocomplete="off"
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="popup_request_phone"
                  maxlength="50"
                  placeholder="Телефон"
                  v-model="requestPopupPhone"
                  autocomplete="off"
                  ref="request_phone"
                />
              </div>
              <div>
                <input
                  type="text"
                  name="popup_request_email"
                  maxlength="50"
                  placeholder="Email"
                  v-model="requestPopupEmail"
                  autocomplete="off"
                />
              </div>
              <div>
                <textarea
                  name="popup_request_msg"
                  maxlength="500"
                  placeholder="Сообщение"
                  v-model="requestPopupMsg"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="_frm-info">
              Нажимая на кнопку «Отправить», вы даете согласие на обработку
              пользовательских данных
            </div>
          </form>
          <transition name="fade-fastly">
            <div class="_frm-result" v-if="requestSent">Спасибо!</div>
          </transition>
          <span
            class="btn"
            :class="{ disabled: requestSent }"
            @click="sendPopupRequestForm"
          >Отправить</span
          >
        </Popup>

        <Popup
          v-show="this.$store.getters.getPopupCookieIsActive"
          :title="'Политика куки-файлов'"
        >
          <div class="texts-small">
            <p>
              «Cookie» — это небольшие текстовые файлы, размещаемые на
              компьютере пользователей с целью анализа их пользовательской
              активности.
            </p>
            <p>
              Мы используем куки для создания анонимной статистики использования
              нашего сайта с помощью сервисов Яндекс.Метрика и Google Analytics.
              Эти анонимные данные мы используем для целей улучшения контента
              сайта, пользовательского опыта, оптимизации пути пользователей на
              сайте для нахождения нужной информации. Вы можете ознакомиться с
              политикой использования этих данных третьими сторонами в разделах
              службы поддержки соответствующих сервисов.
            </p>
            <p>
              Большинство браузеров позволяют отказаться от использования cookie
              файлов. С инструкцией управления cookie файлами через браузер вы
              можете ознакомиться через службу поддержки вашего браузера.
            </p>
          </div>
        </Popup>

        <Popup
          v-show="this.$store.getters.getPopupTermsIsActive"
          :title="'Политика конфиденциальности'"
        >
          <div class="texts-small">
            <p>
              Когда вы используете наш сайт, мы можем собирать персональные
              данные. Продолжая пользоваться нашим сайтом, вы даете согласие на
              обработку персональных данных. Вы передаете нам персональные
              данные, когда заполняете формы обратной связи. Пожалуйста,
              ознакомьтесь с
              <a target="_blank" :href="this.$store.state.termsFile"
              >ПОЛОЖЕНИЕМ ОБ ОБРАБОТКЕ И ЗАЩИТЕ ПЕРСОНАЛЬНЫХ ДАННЫХ</a
              >
              для того, чтобы узнать, как мы собираем, храним и используем
              персональные данные.
            </p>
            <p>
              На этом сайте мы также собираем технические данные, которые
              автоматически передаются устройством и используются нами для
              улучшения работы нашего сайта и пользовательского контента.
            </p>
          </div>
        </Popup>

        <Popup
          v-show="this.$store.getters.getPopupProjectCompleted"
        >
          <div class="pop-up">
            <div class="pop-up-shade" @click="hideProjectPopup" />
              <div class="pop-up-box" :style="{padding: 0, maxWidth: '734px', maxHeight: '236px'}">
                <span class="close" @click="hideProjectPopup"></span>
                <a href="/aparts"><img :src="require('@/assets/img/pop-up-project-completed.png')" :style="{width: '100%'}" alt="" /></a>
                <slot />
              </div>
          </div>
        </Popup>

      </div>
    </transition>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
import Popup from "@/components/Popup"
import Inputmask from "inputmask"
import { applyPageSeo, fetchPageSeo } from "@/utils/seo"

export default {
  // props = {
  //
  // },
  data() {
    return {
      menuActive: false,
      headerFixed: false,
      headerHide: false,
      scrolledY: 0,
      // popupRequestIsActive: false,
      resAddress: "Садовническая улица, 82",
      pages: [
        { id: 1, path: "/about", title: "О проекте", mainMenu: 1 },
        { id: 2, path: "/aparts", title: "Резиденции", mainMenu: 1 },
        { id: 3, path: "/special", title: "Особые форматы", mainMenu: 1 },
        { id: 4, path: "/parking", title: "Машиноместа", mainMenu: 1 },
        { id: 5, path: "/gallery", title: "Галерея", mainMenu: 1 },
        { id: 6, path: "/location", title: "Расположение", mainMenu: 1 },
        { id: 7, path: "/contacts", title: "Контакты", mainMenu: 1 },
        {
          id: 8,
          path: "/documents",
          title: "Проектная документация",
          mainMenu: 0,
        },
        {
          id: 9,
          path: "/gallery",
          title: "Галерея",
          mainMenu: 0,
        },
        { id: 10, path: "/favorites", title: "Избранное", mainMenu: 1 },
      ],

      requestPopupPhone: "",
      requestPopupName: "",
      requestPopupEmail: "",
      requestPopupMsg: "",
      requestSent: false,

      // isTouch: typeof window !== "undefined" && "ontouchstart" in window,
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll)
    this.$root.pages = this.pages

    // .... Trick with viewport height .................................................................................
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`)

    this.$store.dispatch("fetchStartData")
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  mounted() {
    this.syncPageSeo()
    if (this.$route && this.$route.path) {
      fetchPageSeo(this.$route.path)
    }
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.menuActive = false
        document.body.classList.remove("menu-open")
        this.$store.state.popupRequestIsActive = false
        this.$store.state.popupCookieIsActive = false
      }
    })
  },
  updated() {
    // console.log('sdfsdfsdf', this.$store.getters.getPopupCookieIsActive)
    // if (this.$store.getters.getPopupCookieIsActive) {
    var im = new Inputmask("+7 (999) 999-99-99")
    im.mask(this.$refs.request_phone)
    // }
  },
  watch: {
    $route(to, from) {
      if (to && from) this.closeMenu()
      if (to && to.path) {
        fetchPageSeo(to.path)
      }
    },
  },
  methods: {
    syncPageSeo() {
      if (window.__PAGE_SEO__ && window.__PAGE_SEO__.title) {
        applyPageSeo(window.__PAGE_SEO__)
        return
      }
      if (this.activePage != undefined) {
        document.title = this.activePage.title
      } else {
        document.title =
          "A.Residence – Комплекс премиальных резиденций в центре Москвы"
      }
    },
    handleScroll() {
      if (this.$route.path == "/")
        this.headerFixed = window.scrollY > window.innerHeight
      else this.headerFixed = window.scrollY > 0

      if (window.scrollY > 0 && window.scrollY > this.scrolledY)
        this.headerHide = true
      else this.headerHide = false

      this.scrolledY = window.scrollY
    },
    toggleMenu() {
      this.menuActive = !this.menuActive
      this.menuActive
        ? document.body.classList.add("menu-open")
        : document.body.classList.remove("menu-open")
    },
    closeMenuAndGoUp() {
      this.closeMenu()
      window.scrollTo(0, 0)
    },
    closeMenu() {
      this.menuActive = false
      document.body.classList.remove("menu-open")
    },
    escAll() {
      // console.log('sdfsdfsd');
      // alert('sdfsdf');
    },
    activateTermsPopup() {
      this.$store.dispatch("changeTermsPopupActive", true)
    },
    async sendPopupRequestForm() {
      if (!this.requestSent) {
        const rawResponse = await fetch(
          this.$store.getters.getApiUrl + "new_req",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: this.requestPopupName,
              phone: this.requestPopupPhone,
              email: this.requestPopupEmail,
              msg: this.requestPopupMsg,
              apart: this.$store.getters.getActiveFlat,
            }),
          },
        )
        const content = await rawResponse.json()
        if (content.status == 1) this.requestSent = true
      }

      // alert('Отсылаем: ' + this.requestPopupName + ' – ' + this.requestPopupPhone + ' - ' + this.requestPopupEmail + ' - ' + this.requestPopupMsg);
    },
    hideProjectPopup() {
      this.$store.state.popupProjectCompleted = false
    },
  },
  computed: {
    activePage() {
      return this.pages.filter((p) => {
        return p.path == this.$route.path
      })[0]
      // console.log(page[0]);
      // return page;
    },
    pagesForMenu() {
      return this.pages.filter((p) => {
        return p.mainMenu == 1
      })
    },
    instUrl() {
      return this.$store.getters.getContacts.instagram
    },
    tgUrl() {
      return this.$store.getters.getContacts.telegram
    },
  },
  components: {
    Footer,
    Popup,
  },
}
</script>
